var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TikTok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    ry: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 10.28v-.65c-.22-.03-.44-.05-.67-.05a4.95 4.95 0 0 0-4.94 4.94c0 1.67.84 3.15 2.11 4.05a4.919 4.919 0 0 1-1.31-3.36c0-2.69 2.14-4.86 4.81-4.92Z",
    fill: "#25f4ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.52 17.48c1.22 0 2.22-.98 2.27-2.19V4.55h1.96v-.02c-.04-.22-.07-.45-.07-.68H12v10.76a2.267 2.267 0 0 1-2.26 2.17c-.38 0-.73-.09-1.05-.26.41.57 1.08.95 1.83.95ZM18.42 8.22v-.63c-.75 0-1.45-.22-2.03-.6.52.6 1.23 1.06 2.03 1.24Z",
    fill: "#25f4ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.38 6.98a3.73 3.73 0 0 1-.92-2.45h-.73c.19 1.02.81 1.9 1.65 2.45ZM9.74 12.25c-1.24 0-2.27 1.03-2.27 2.28 0 .87.51 1.62 1.22 2-.27-.37-.43-.82-.43-1.32a2.264 2.264 0 0 1 2.93-2.16v-2.74c-.22-.03-.44-.05-.67-.05h-.13v2.08c-.22-.07-.42-.1-.66-.1Z",
    fill: "#fe2c55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.42 8.18h-.01v2.07c-1.39 0-2.69-.46-3.74-1.21v5.48c0 2.72-2.2 4.93-4.92 4.93a4.92 4.92 0 0 1-2.83-.88c.9.97 2.19 1.58 3.61 1.58a4.95 4.95 0 0 0 4.94-4.94V9.75c1.05.76 2.34 1.2 3.73 1.2V8.27c-.27 0-.53-.03-.78-.08Z",
    fill: "#fe2c55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.68 14.53V9.07c1.05.76 2.34 1.2 3.73 1.2V8.18c-.8-.17-1.51-.6-2.03-1.2a3.765 3.765 0 0 1-1.64-2.45h-1.97v10.76a2.267 2.267 0 0 1-2.26 2.17c-.75 0-1.42-.37-1.83-.94a2.257 2.257 0 0 1-1.21-2 2.264 2.264 0 0 1 2.93-2.16v-2.1a4.94 4.94 0 0 0-4.82 4.94c0 1.3.5 2.48 1.33 3.36.8.56 1.78.9 2.83.9a4.95 4.95 0 0 0 4.94-4.94Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTiktok);
export default __webpack_public_path__ + "static/media/social-tiktok.5e0a66165d19ac4f8dd17ee70331caf8.svg";
export { ForwardRef as ReactComponent };